import { call, put, select } from 'redux-saga/effects';
import { TEXT_TYPES_CODES } from '../catalogConstants';
import { getCustomerProductsToHireProductOffering as getCustomerProductsToHireProductOfferingAda } from '@bitComponents/adabyron/cqv2';
import { getProductOfferingTextByType } from '../utils/general';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

const normalizeParentProductsToSelect = (products) => {
  const { choices } = products[0];

  const choicesToReturn = [];

  if (choices && Array.isArray(choices) && choices.length > 0) {
    choices.forEach((choice) => {
      const choiceNormalized = {
        phoneNumber: choice.clientPhoneNumberToBeAppliedTo,
        id: choice.id,
      };

      if (choice.productOffering) {
        choiceNormalized.text = getProductOfferingTextByType(choice.productOffering, TEXT_TYPES_CODES.BRIEF);
      }

      choicesToReturn.push(choiceNormalized);
    });
  } else {
    return null;
  }
  return choicesToReturn;
};

export function* getCustomerProductsToHireProductOffering(params) {
  const {
    productOffering,
    reduxUpdate,
    normalizeHttpErrors,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const response = yield call(getCustomerProductsToHireProductOfferingAda, { productOffering }, context);
    if (response && response.products && Array.isArray(response.products)) {
      const normalizedResponse = normalizeParentProductsToSelect(response.products);
      yield put(successUpdate(normalizedResponse));
      return normalizedResponse;
    }
    throw new Error();
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_CUSTOMER_PRODUCTS_TO_HIRE_PRODUCT_OFFERING, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
